import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { TableColumnsEnum, transactionsProxy } from '../../../../../shared/proxies/transactionsProxy'
import { TransactionListTableFooter } from './components/TransactionListTableFooter'
import { TransactionsRows } from './TransactionsRows/TransactionsRows'
import { TableHeader } from './components/TableHeader'

export function TransactionsTable (): ReactElement {
  const { apiCall } = useSnapshot(transactionsProxy)
  return (
    <div className="w-full">
      <PlaceholderBox loading={apiCall.loading} rows={20} additionalClasses="p-2">
        <ErrorBox error={apiCall.error}>
          <table className="w-full">
            <thead className="text-left">
              <tr>
                <TableHeader title="Id" width={6} sortColumn={TableColumnsEnum.Id} />
                <TableHeader title="Date" width={10} sortColumn={TableColumnsEnum.TransactedAt} />
                <TableHeader title="Company" width={15} sortColumn={TableColumnsEnum.CompanyName} />
                <TableHeader title="Invoice" width={10} sortColumn={TableColumnsEnum.InvoiceNumber} />
                <TableHeader title="Status" width={11} sortColumn={TableColumnsEnum.Status} />
                <TableHeader title="Type" width={10} sortColumn={TableColumnsEnum.Type} />
                <TableHeader title="Amount" width={9} sortColumn={TableColumnsEnum.Amount} />
              </tr>
            </thead>
            <tbody>
              <TransactionsRows />
            </tbody>
          </table>
          <hr />
          <TransactionListTableFooter />
        </ErrorBox>
      </PlaceholderBox>
    </div>

  )
}
